var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinCommunityGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1069,
    height: 470,
    viewBox: "0 0 1069 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.641 0V470",
    stroke: "url(#paint0_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.16 0V470",
    stroke: "url(#paint1_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M355.68 0V470",
    stroke: "url(#paint2_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M476.199 0V470",
    stroke: "url(#paint3_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M596.719 0V470",
    stroke: "url(#paint4_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M717.238 0V470",
    stroke: "url(#paint5_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M837.758 0V470",
    stroke: "url(#paint6_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M958.281 0V470",
    stroke: "url(#paint7_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 391.715L1069 391.715",
    stroke: "url(#paint8_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 280.199L1069 280.199",
    stroke: "url(#paint9_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 168.68L1069 168.68",
    stroke: "url(#paint10_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 56.2266L1069 56.2266",
    stroke: "url(#paint11_linear_1877_15336)",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_15336",
    x1: 115.141,
    y1: 0,
    x2: 115.141,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1877_15336",
    x1: 235.66,
    y1: 0,
    x2: 235.66,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1877_15336",
    x1: 356.18,
    y1: 0,
    x2: 356.18,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1877_15336",
    x1: 476.699,
    y1: 0,
    x2: 476.699,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1877_15336",
    x1: 597.219,
    y1: 0,
    x2: 597.219,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1877_15336",
    x1: 717.738,
    y1: 0,
    x2: 717.738,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1877_15336",
    x1: 838.258,
    y1: 0,
    x2: 838.258,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1877_15336",
    x1: 958.781,
    y1: 0,
    x2: 958.781,
    y2: 470,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1877_15336",
    x1: 0,
    y1: 391.215,
    x2: 1069,
    y2: 391.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1877_15336",
    x1: 0,
    y1: 279.699,
    x2: 1069,
    y2: 279.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1877_15336",
    x1: 0,
    y1: 168.18,
    x2: 1069,
    y2: 168.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1877_15336",
    x1: 0,
    y1: 55.7266,
    x2: 1069,
    y2: 55.7266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinCommunityGrid);
export default __webpack_public_path__ + "static/media/JoinCommunityGrid.9b1b7d507b07db261a9a532d9e382d75.svg";
export { ForwardRef as ReactComponent };